<template>
  <div class="checkout_success">
    <div class="label_title">
      訂單資訊
    </div>
    <div class="info_area">
      <div style="height: 48px;"/>
      <div class="title">{{ title }}</div>
      <div style="height: 18px;"/>
      <div class="subtitle">{{ subtitle }}</div>
      <div style="height: 18px;"/>
      <div class="order_person">
        <div class="order_num">訂單編號: <span id="trade_no">{{ orderNum }}</span>
          <a class="copy" target="_blank" title="copy" @click="clickCopy">
            <img class="copy" src="/img/image/icon/copy.png" loading="lazy" alt="copy"/>
          </a>
        </div>
        <div style="height: 10px;"/>
        <div class="order_info">訂購人:{{ name }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">連絡電話:{{ phone }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">電子信箱:{{ email }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">收件地址:{{ address }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">備註:{{ note }}</div>
        <div style="height: 10px;"/>
        <div class="order_info">帳號末五碼:{{ state }}</div>
        <div style="height: 32px;"/>
        <div class="row no-gutters">
          <div class="col text_style">商品</div>
          <div class="row no-gutters amount_area">
            <div class="col-auto text_style">數量</div>
            <div class="col-auto text_style">小計</div>
          </div>
        </div>
        <div style="height: 8px;"/>
        <div class="divider"/>
        <div style="height: 8px;"/>
        <div v-for="(item,index) in commodityList" :key="index">
          <OrderCommodity :index="index" :item="item"/>
        </div>
        <div style="height: 8px;"/>
        <div class="divider"/>
        <div style="height: 8px;"/>
        <div class="subtotal">
          <div class="row">
            <div class="col subtotal_label">小計</div>
            <div class="price">NT$ {{ price }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">低溫宅配</div>
            <div class="price">NT$ {{ feeText }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">付款金額總計</div>
            <div class="total_price">NT$ {{ totalPriceText }}</div>
          </div>
          <div style="height: 32px"/>
        </div>
      </div>
      <div class="notice_area">
        <div class="title">注意事項</div>
        <div style="height: 4px"/>
        <div class="info">1.訂單資訊已寄信至訂購人電子信箱。</div>
        <div style="height: 4px"/>
        <div class="info">2.至「查詢訂單」頁面，輸入訂單編號可以查詢訂單寄送狀態。</div>
        <div style="height: 4px"/>
        <div class="info">3.完成結帳後，訂單寄送狀態會同步寄信至訂購人電子信箱。</div>
        <div style="height: 4px"/>
        <div class="info">4.登入Line可以第一時間收到訂單寄送狀態通知</div>
        <div style="height: 4px"/>
        <div class="info">5.如有任何問題請透過以下方式聯繫客服。</div>
        <div style="height: 24px"/>
      </div>
      <div class="notice_divider">
        <div class="divider"/>
      </div>
      <div style="height: 42px"/>
      <div class="down_area">
        <div class="row  no-gutters down_btn_area">
          <div class="row no-gutters">
            <button type="button" class="btn btn_icon_style " @click="clickBtn('instagram')">
              <img src="/img/image/icon/ig.png" class="icon" loading="lazy" alt="instagram"/>
            </button>
            <div class="icon_space"/>
            <button type="button" class="btn btn_icon_style" @click="clickBtn('line')">
              <img src="/img/image/icon/line.png" class="icon" loading="lazy" alt="Line"/>
            </button>
          </div>
          <div class="row no-gutters align-items-center line_area">
            <div class="line_join_hint">加入LINE追蹤訂單進度</div>
            <div class="line_join_hint_space" style="width: 45px"/>
            <button type="button" class="btn btn_style btn-line" @click="clickBtn('line')">
              <span class="btn_text">LINE登入</span>
            </button>
          </div>
        </div>
      </div>
      <div style="height: 12px"/>
    </div>
  </div>
</template>

<script>
import {copyText, getPrice, isEmpty} from "../../util/helpers";
import OrderCommodity from "../../components/OrderCommodity";
import Clipboard from "clipboard";
import AlertDialog from "../dialog/AlertDialog";
import {formatOrderStatus} from "../../util/formatter_generated";
//單頁面引用

export default {
  name: "SuccessOrder",
  components: {OrderCommodity},
  props: {
    order: Object,
  },
  data() {
    return {};
  },
  computed: {
    orderAddress() {
      let val = this.order.OrderAddress;
      return isEmpty(val) ? null : val;
    },
    paidUpdate() {
      let val = this.order.PaidUpdate;
      return isEmpty(val) === false;
    },
    transportingUpdate() {
      let val = this.order.TransportingUpdate;
      return isEmpty(val) === false;
    },
    completedUpdate() {
      let val = this.order.CompletedUpdate;
      return isEmpty(val) === false;
    },
    cancelUpdate() {
      let val = this.order.CancelUpdate;
      return isEmpty(val) === false;
    },
    orderStatus() {
      let val = this.order.order_status;
      return isEmpty(val) ? 6 : val;
    },
    title() {
      switch (this.orderStatus) {
        case 1:
          return "";
        case 2:
          return "匯款成功";
        case 3:
          return "商品已寄出";
        case 4:
          return "訂單完成";
        case 5:
          return "訂單已取消";
        default:
        case 6:
          return "確認匯款中";
      }
    },
    subtitle() {
      switch (this.orderStatus) {
        case 1:
          return "";
        case 2:
          return "訂單匯款完成，商品包裝中，我們將儘速為您發貨。";
        case 3:
          return "訂單已發貨，商品將在7-14工作天內送到。";
        case 4:
          return "滿香脆感謝您的訂購，如果有任何疑問歡迎洽官方LINE留下訊息。";
        case 5:
          return "訂單已取消，若有疑問請聯絡官方LINE訊息。";
        default:
        case 6:
          return "感謝您的下訂，我們正為您確認訂單。";
      }
    },
    orderNum() {
      let val = this.order.trade_no;
      return isEmpty(val) ? "" : val;
    },
    name() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.receiver_name;
      return isEmpty(val) ? "" : val;
    },
    phone() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.phone_number;
      return isEmpty(val) ? "" : val;
    },
    address() {
      if (isEmpty(this.orderAddress)) return '';
      let val = this.orderAddress.address;
      return isEmpty(val) ? "" : val;
    },
    note() {
      if (isEmpty(this.orderAddress)) return '無';
      let val = this.orderAddress.note;
      return isEmpty(val) ? "無" : val;
    },
    user() {
      let val = this.order.User;
      return isEmpty(val) ? null : val;
    },
    email() {
      let val = this.user.email;
      return isEmpty(val) ? "" : val;
    },
    state() {
      return this.order.pay_info;
    },
    commodityList() {
      let val = this.order.OrderCommodities;
      return isEmpty(val) ? [] : val;
    },
    fee() {
      let val = this.order.shipping_fee;
      return isEmpty(val) ? 0 : val;
    },
    feeText() {
      return getPrice(this.fee);
    },
    price() {
      return getPrice(this.totalPrice - this.fee);
    },
    totalPrice() {
      let val = this.order.price;
      return isEmpty(val) ? 0 : val;
    },
    totalPriceText() {
      return getPrice(this.totalPrice);
    },
    settingData() {
      return this.$store.getters.getSettingData;
    },
    instagramUrl() {
      let val = this.settingData.data.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    isNotEmpty(val) {
      return isEmpty(val) === false;
    },
    clickBtn(type) {
      switch (type) {
        case "line":
          window.open(this.lineUrl, '_blank');
          return;
        case "instagram":
          window.open(this.instagramUrl, '_blank');
          return;
      }
    },
    async clickCopy() {
      try {
        if (isEmpty(this.orderNum) === false) {
          let result = await copyText(this.orderNum);
          if (result) {
            await this.$dialog.show(AlertDialog, {text: "複製成功"});
          } else {
            await this.$dialog.show(AlertDialog, {text: "複製失敗"});
          }
        }
      } catch (e) {
        console.log('error clickCopy :', e);
        await this.$dialog.show(AlertDialog, {text: "複製失敗"});
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.checkout_success {
  width: 1120px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .checkout_success {
    width: 77vw;
  }
}

@media (max-width: 1024px) {
  .checkout_success {
    width: 90vw;
  }
}

@media (max-width: 576px) {
  .checkout_success {
    width: 100%;
  }
}


.label_title {
  background-color: #333333;
  padding: 10px 24px 10px 24px;
  color: white;
  font-size: 20px;
  font-weight: 500;
}


.info_area {
  background-color: #FAFAFA;
}

.amount_area {
  width: 270px;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .amount_area {
    width: 26vw;
  }
}

.text_style {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.input_area {
  padding-left: 24px;
  padding-right: 24px;
}

.text_label {
  max-width: 160px;
  width: 160px;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.must {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

.input_style {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding: 12px;
  //border-radius: 5px;
  border: 0.5px solid #DDE1E9;
  resize: none; /* 禁用用户调整大小 */
  overflow: auto; /* 确保超出内容时可以滚动 */
}

.input_style::placeholder {
  color: #888;
}

textarea {
  width: 100%;
}

.divider {
  width: auto;
  height: 1px;
  background-color: #D56835;
}

.subtotal {
  width: 50%;
  margin: 0 0 0 auto;
  padding-right: 24px;
}


.subtotal_label {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.price {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #333333;
}

.total_price {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #D56835;
}


.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  color: #333333;

}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: white; /* 背景顏色 */
  border: 2px solid #D56835; /* 邊框顏色和寬度 */
  border-radius: 3px; /* 邊框圓角 */
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #D56835;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.btn_area {
  text-align: end;
  padding-right: 10px;
}

.btn_style {
  width: 230px;
  height: 56px;
  line-height: 0;
}

@media (max-width: 700px) {
  .btn_style {
    width: 200px;
    height: 48px;
  }
}

@media (max-width: 425px) {
  .btn_style {
    width: 130px;
    height: 32px;
  }
}

.btn_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: white;
}

@media (max-width: 700px) {
  .btn_text {
    line-height: 0;
    font-size: 20px;
  }
}

@media (max-width: 425px) {
  .btn_text {
    line-height: 0;
    font-size: 16px;
  }
}

.title {
  font-family: Noto Sans TC;
  font-size: 36px;
  font-weight: 500;
  text-align: center;
  color: black;
}

@media (max-width: 360px) {
  .title {
    font-size: 24px;
  }
}

.subtitle {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: center;
  color: #333333;
}

@media (max-width: 768px) {
  .subtitle {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .subtitle {
    font-size: 14px;
  }
}

.order_person {
  padding: 0 74px;
}

@media (max-width: 768px) {
  .order_person {
    padding: 0 50px;
  }
}

@media (max-width: 360px) {
  .order_person {
    padding: 0 16px;
  }
}

.order_num {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

.order_info {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.order_person > .divider {
  background-color: #CBD2E1;
}


.payment_info {
  background-color: #FFFFFF;
  padding: 32px;
  margin-right: 74px;
  margin-left: 74px;
}

@media (max-width: 768px) {
  .payment_info {
    padding: 16px;
    margin-right: 50px;
    margin-left: 50px;
  }
}

@media (max-width: 425px) {
  .payment_info {
    padding: 8px;
    margin-right: 16px;
    margin-left: 16px;
  }
}


.payment_info .title {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

.notice_area {
  padding-left: 105px;
  padding-right: 105px;
}

@media (max-width: 768px) {
  .notice_area {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 425px) {
  .notice_area {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media (max-width: 360px) {
  .notice_area {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.notice_area .title {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .notice_area .info {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .notice_area .title {
    font-size: 16px;
  }
}


.notice_area .info {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}


@media (max-width: 425px) {
  .notice_area .info {
    font-size: 14px;
  }
}

.notice_divider {
  padding-right: 24px;
  padding-left: 24px;
}

.btn_icon_style {
  padding: 0;
  margin: 0;
  border-radius: 50%;
  width: 36px;
  height: 36px
}

.icon {
  width: 36px;
  height: 36px
}


.down_area {
  padding-left: 82px;
  padding-right: 24px;
  height: 56px;
}

@media (max-width: 768px) {
  .down_area {
    padding-left: 60px;
    padding-right: 24px;
  }
}

@media (max-width: 360px) {
  .down_area {
    padding-left: 24px;
    padding-right: 16px;
  }
}

.down_btn_area {
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 700px) {
  .down_btn_area {
    align-items: end;
  }
}

.icon_space {
  width: 20px;
}

@media (max-width: 700px) {
  .icon_space {
    width: 10px;
  }
}


.line_area {

}

@media (max-width: 700px) {
  .line_area {
    flex-direction: column;
  }
}

.line_join_hint {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

@media (max-width: 700px) {
  .line_join_hint {
    font-size: 18px;
  }
}

@media (max-width: 576px) {
  .line_join_hint {
    font-size: 16px;
  }
}

@media (max-width: 360px) {
  .line_join_hint {
    font-size: 14px;
  }
}


.line_join_hint_space {
  width: 45px;
}

@media (max-width: 700px) {
  .line_join_hint_space {
    height: 15px;
  }
}

.copy {
  width: 20px;
  height: 20px;
  cursor: pointer;
}


</style>
